/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import * as useripAPIUtil from 'utils/api/userip';

/* ========== ~~~~~~~~~~ SESSION STATUS : ACTIONS ~~~~~~~~~~ ========== */
// ACTION
// utilized by reducers as a call to action to perform some kind of update to application state
// utilized in "_container" components and reducers



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

export const SET_SESSION_DATA = 'SET_SESSION_DATA';
export const SET_USER_GEO_IP = 'SET_USER_GEO_IP';
export const RECEIVE_ERRORS = 'RECEIVE_ERRORS';
export const OPT_IN = 'OPT_IN';
export const EXCLUDE_QUESTIONNAIRE = 'EXCLUDE_QUESTIONNAIRE';
export const SET_USER_GEO_FROM_SETTINGS = 'SET_USER_GEO_FROM_SETTINGS';

// ACTIONS USED BY THUNKS TO COMMUNICATE WITH A REDUCER
const setUserGeoIP = geoIp => ({
        type: SET_USER_GEO_IP,
        geoIp
});
const setUserGeoFromSettings = () => ({
    type: SET_USER_GEO_FROM_SETTINGS
});


// ACTIONS THAT CAN BE IMPORTED AND USED IN COMPONENTS
export const setSessionData = sessionData => ({
    type: SET_SESSION_DATA,
    sessionData
});
export const optUserIn = () => ({
   type: OPT_IN
});

export const excludeQuestionnaire = questionnaire => ({
    type: EXCLUDE_QUESTIONNAIRE,
    questionnaire
});

// THUNKS
export const getUserGeoIp = () => dispatch => (
    useripAPIUtil.getUserIP()
        .then(response => dispatch(setUserGeoIP(JSON.parse(response))),
            () => dispatch(setUserGeoFromSettings()))
);
